import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["allocatedTotal", "remainingCredit"]
    static values = { remaining: Number, currency: String }

    connect() {
        this.amountInputs = this.element.querySelectorAll(".allocation-amount")

        this.element.querySelectorAll(".settlement-amount").forEach(input => input.addEventListener("input", () => this.recalculate()))
        this.amountInputs.forEach(input => {
            input.addEventListener("input", () => this.recalculate())
            input.addEventListener("focus", (e) => this.autoFillRow(e))
        })

        // ✅ Auto allocate once on load
        this.initialAutoAllocate()

        this.recalculate()
    }

    // -----------------------------
    // Initial auto distribution
    // -----------------------------
    initialAutoAllocate() {
        let remaining = this.remainingValue

        this.amountInputs.forEach(input => {
            if (remaining <= 0 || input.closest("tr").querySelector(".settlement-amount")) return

            const amountDue = parseFloat(input.dataset.amountDue) || 0
            const assign = Math.min(amountDue, remaining)

            input.value = assign > 0 ? assign.toFixed(4) : ""
            remaining -= assign
        })
    }

    // -----------------------------
    // Auto fill when focusing empty input
    // -----------------------------
    autoFillRow(event) {
        const input = event.target
        if (input.closest("tr").querySelector(".settlement-amount")) return
        const current = parseFloat(input.value) || 0

        if (current > 0) return

        const remaining = this.calculateRemaining()
        if (remaining <= 0) return

        const amountDue = parseFloat(input.dataset.amountDue) || 0
        const assign = Math.min(amountDue, remaining)

        input.value = assign.toFixed(4)
        this.recalculate()
    }

    // -----------------------------
    // Recalculate totals
    // -----------------------------
    recalculate() {
        let totalAllocated = 0

        this.amountInputs.forEach(input => {
            const cashInput = input.closest("tr").querySelector(".settlement-amount") || input
            const value = parseFloat(cashInput.value) || 0
            totalAllocated += value
        })

        const remaining = this.remainingValue - totalAllocated

        this.allocatedTotalTarget.innerText = this.format(totalAllocated)
        this.remainingCreditTarget.innerText = this.format(remaining)

        const isOverAllocated = remaining < 0

        // Show red color
        this.remainingCreditTarget.classList.toggle("fg-danger", isOverAllocated)

        // 🔥 Dispatch event to dialog
        this.element.dispatchEvent(
            new CustomEvent("form:state", {
                bubbles: true,
                detail: { valid: !isOverAllocated }
            })
        )
    }

    calculateRemaining() {
        let totalAllocated = 0

        this.amountInputs.forEach(input => {
            const cashInput = input.closest("tr").querySelector(".settlement-amount") || input
            const value = parseFloat(cashInput.value) || 0
            totalAllocated += value
        })

        return this.remainingValue - totalAllocated
    }

    format(amount) {
        return new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: this.currencyValue
        }).format(amount)
    }
}